__webpack_require__.p = "/kendo-react/react-coffee-warehouse/";